import axios from 'axios'
import Cookies from 'js-cookie'
import { apiUrl, authApi, authRoutes } from './config'

const credentials = { withCredentials: true }

function friendlyError(error, fallback) {
  const data = error && error.response && error.response.data
  if (data && data.friendly && data.friendly.da) {
    return data.friendly.da
  }
  if (data && data.friendly && typeof data.friendly === 'string') {
    return data.friendly
  }
  return fallback
}

/** Exchange a Clerk session JWT for our PHP ua_token session. */
export async function exchangeClerkToken(token) {
  const response = await axios.post(
    apiUrl(authApi.clerkBridge),
    {},
    {
      ...credentials,
      headers: { Authorization: 'Bearer ' + token }
    }
  )
  return response.data
}

/** Classic email + password login. */
export async function loginWithPassword(email, password) {
  const response = await axios.post(
    apiUrl(authApi.passwordLogin),
    { email, password },
    credentials
  )
  return response.data
}

/** Load current app user (PHP session / ua_token). */
export async function fetchCurrentUser() {
  const response = await axios.get(apiUrl(authApi.currentUser), credentials)
  return response.data
}

/** Sign out of Clerk (if present) and clear PHP session + local cookies. */
export async function logout() {
  if (window.Clerk && typeof window.Clerk.signOut === 'function') {
    try {
      await window.Clerk.signOut()
    } catch (e) {
      // Clerk may already be signed out
    }
  }

  await axios.get(apiUrl(authApi.logout), credentials)
  Cookies.remove('authToken')
  Cookies.remove('uat')
}

export function clearLocalUser(globalOrRef) {
  const target = globalOrRef && Object.prototype.hasOwnProperty.call(globalOrRef, 'value')
    ? globalOrRef.value
    : globalOrRef
  if (target) {
    target.user = { authentificated: false }
  }
}

export function redirectHome() {
  window.location.href = authRoutes.home
}

export { friendlyError }
